import { ServiceData } from '@/types';

import articles from './LOVE_ARTICLES_EN.json';
import audios from './LOVE_AUDIOS_EN.json';

export const LOVE_DATA_EN: ServiceData = {
  articles,
  audios,
};
